import SearchTextField, { SearchTextFieldStyles } from "@eisinc/Overrides/Widgets/OrderHistory/SearchTextField";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderHistoryPageContext } from "@insite/content-library/Pages/OrderHistoryPage";
import * as React from "react";

export const orderTypeStyles: SearchTextFieldStyles = {};
const styles = orderTypeStyles;

const OrderHistorySearchFieldOrderType: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="orderType"
            label="Order Type"
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterOrderType"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldOrderType,
    definition: {
        group: "Order History",
        allowedContexts: [OrderHistoryPageContext],
        displayName: "Order Type",
    },
};

export default widgetModule;
